import { createSlice } from '@reduxjs/toolkit'

const initialPlansState = {
	listLoading: false,
	actionsLoading: false,
	totalCount: 0,
	entities: [],
	planForEdit: undefined,
	lastError: null,
}
export const callTypes = {
	list: 'list',
	action: 'action',
}

export const plansSlice = createSlice({
	name: 'plans',
	initialState: initialPlansState,
	reducers: {
		catchError: (state, action) => {
			state.error = action.payload.error
			if (action.payload.callType === callTypes.list) {
				state.listLoading = false
			} else {
				state.actionsLoading = false
			}
		},
		startCall: (state, action) => {
			state.error = null
			if (action.payload.callType === callTypes.list) {
				state.listLoading = true
			} else {
				state.actionsLoading = true
			}
		},
		// findPlans
		plansFetched: (state, action) => {
			const { totalCount, entities } = action.payload
			state.listLoading = false
			state.error = null
			state.entities = entities
			state.totalCount = totalCount
		},
		// createPlan
		planCreated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			state.entities.push(action.payload.plan)
		},
		// updatePlan
		planUpdated: (state, action) => {
			state.error = null
			state.actionsLoading = false
			const updatedPlan = action.payload.plan
			state.entities = state.entities.map((entity) => {
				if (entity.id === updatedPlan.id) {
					return { ...entity, ...updatedPlan }
				}
				return entity
			})
		},
		// updateStatus
		statusUpdated: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.map((entity) => {
				if (entity.id === action.payload.id) {
					entity.status = action.payload.status
				}
				return entity
			})
		},
		// updateStatus
		autoChargeUpdated: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.map((entity) => {
				if (entity.id === action.payload.id) {
					entity.auto_charge = action.payload.auto_charge
				}
				return entity
			})
		},
		// updateStatus
		buttonUpdated: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.map((entity) => {
				if (entity.id === action.payload.id) {
					entity.enable_button = action.payload.enable_button
				}
				return entity
			})
		},
		// deletePlan
		planDeleted: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.filter(
				(el) => el.id !== action.payload.id,
			)
		},
	},
})
